if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      if(!this.hasAttribute('available')) return;

      this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.fetchAvailability(this.dataset.variantId);
    }

    fetchAvailability(variantId) {
      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);
        })
        .catch(e => {
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
      this.innerHTML = '';
      this.appendChild(this.errorHtml);

      this.querySelector('button').addEventListener('click', this.onClickRefreshList);
    }

    renderPreview(sectionInnerHTML) {
      const drawer = document.querySelector('pickup-availability-drawer');
      if (drawer) drawer.remove();
      if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
        this.innerHTML = "";
        this.removeAttribute('available');
        return;
      }

      this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
      this.setAttribute('available', '');

      document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));

      const button = this.querySelector('button');
      if (button) button.addEventListener('click', (evt) => {
        document.querySelector('pickup-availability-drawer').show(evt.target);
      });
    }
  });
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define('pickup-availability-drawer', class PickupAvailabilityDrawer extends HTMLElement {
    constructor() {
      super();

      this.onBodyClick = this.handleBodyClick.bind(this);

      this.querySelector('button').addEventListener('click', () => {
        this.hide();
      });

      this.addEventListener('keyup', (event) => {
        if(event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
    }

    handleBodyClick(evt) {
      const target = evt.target;
      if (target != this && !target.closest('pickup-availability-drawer') && target.id != 'ShowPickupAvailabilityDrawer') {
        this.hide();
      }
    }

    hide() {
      this.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClick);
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.focusElement);
    }

    show(focusElement) {
      this.focusElement = focusElement;
      this.setAttribute('open', '');
      document.body.addEventListener('click', this.onBodyClick);
      document.body.classList.add('overflow-hidden');
      trapFocus(this);
    }
  });
}

/* Prevent repeated clicks on the "Yes, Add to Cart" button */
(function () {
  if (window.tomProductSubmitLockLoaded) return;

  window.tomProductSubmitLockLoaded = true;

  function buttonIsYesAddToCart(button) {
    if (!button) return false;
    var text = (button.textContent || button.value || '').replace(/\s+/g, ' ').trim().toLowerCase();
    return text.indexOf('yes') !== -1 && text.indexOf('add to cart') !== -1;
  }

  function lockButton(button) {
    if (!button) return;

    button.dataset.tomProductSubmitLocked = 'true';
    button.classList.add('tom-product-submit-locked');
    button.setAttribute('aria-disabled', 'true');
    button.style.pointerEvents = 'none';
    button.style.opacity = '0.55';
    button.style.cursor = 'not-allowed';
  }

  function unlockButtons() {
    document.querySelectorAll('[data-tom-product-submit-locked="true"]').forEach(function (button) {
      button.dataset.tomProductSubmitLocked = 'false';
      button.classList.remove('tom-product-submit-locked');
      button.removeAttribute('aria-disabled');
      button.style.pointerEvents = '';
      button.style.opacity = '';
      button.style.cursor = '';
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.product-form__submit');
    if (!buttonIsYesAddToCart(button)) return;

    if (button.dataset.tomProductSubmitLocked === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return false;
    }

    window.setTimeout(function () {
      lockButton(button);
      setTimeout(unlockButtons, 5000);
    }, 0);
  }, true);

  var observer = new MutationObserver(function () {
    var activeModal = document.querySelector('.bcpo-modal-parent.bcpo-modal-active');
    if (!activeModal) return;

    var modalText = activeModal.textContent || '';
    if (modalText.indexOf('Item added to the cart') !== -1 || modalText.indexOf('Something went wrong') !== -1) {
      unlockButtons();
    }
  });

  function startObserver() {
    if (!document.body) {
      window.setTimeout(startObserver, 50);
      return;
    }

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  startObserver();
})();